import { render, staticRenderFns } from "./platform-data-query.vue?vue&type=template&id=66f182a4&scoped=true&"
import script from "./platform-data-query.vue?vue&type=script&lang=js&"
export * from "./platform-data-query.vue?vue&type=script&lang=js&"
import style0 from "./platform-data-query.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./platform-data-query.vue?vue&type=style&index=1&id=66f182a4&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f182a4",
  null
  
)

export default component.exports